import { UserRole } from "@/entities/user/user"

interface Props {
   selectedStatus: "all" | "active" | "inactive"
   setSelectedStatus: (status: "all" | "active" | "inactive") => void
   selectedRole: "all" | UserRole
   setSelectedRole: (role: "all" | UserRole) => void
}

export function UserFilterBar({
   selectedStatus,
   setSelectedStatus,
   selectedRole,
   setSelectedRole,
}: Props) {
   return (
      <div className="mx-2  flex gap-4 flex-wrap items-center">
         <div className="filter-bar flex-grow">
            <span className="label">Statut</span>

            <button
               className={`btn btn-sm ${selectedStatus === "all" ? "btn-neutral" : "btn-ghost"}`}
               onClick={() => setSelectedStatus("all")}
            >
               Tous
            </button>
            <button
               className={`btn btn-sm ${selectedStatus === "active" ? "btn-neutral" : "btn-ghost"}`}
               onClick={() => setSelectedStatus("active")}
            >
               Actifs
            </button>
            <button
               className={`btn btn-sm ${selectedStatus === "inactive" ? "btn-neutral" : "btn-ghost"}`}
               onClick={() => setSelectedStatus("inactive")}
            >
               Inactifs
            </button>
         </div>

         <div className="filter-bar flex-grow">
            <span className="label">Rôle</span>

            <button
               className={`btn btn-sm ${selectedRole === "all" ? "btn-neutral" : "btn-ghost"}`}
               onClick={() => setSelectedRole("all")}
            >
               Tous
            </button>
            <button
               className={`btn btn-sm ${selectedRole === "admin" ? "btn-neutral" : "btn-ghost"}`}
               onClick={() => setSelectedRole("admin")}
            >
               Admin
            </button>
            <button
               className={`btn btn-sm ${selectedRole === "young" ? "btn-neutral" : "btn-ghost"}`}
               onClick={() => setSelectedRole("young")}
            >
               Jeune
            </button>
         </div>
      </div>
   )
}
